import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/rickroll-roll.gif'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-light py-5 px-md-5 h-100 w-100 overflow-auto position-relative\"><div class=\"container\"><h1 class=\"mb-0\">Náklady</h1><div class=\"mt-4\"><p class=\"lead\">Toto je hudba budoucnosti :-)</p><img src=\"" + _imports_0 + "\" alt=\"Maybe later...\" width=\"640\" height=\"640\"></div></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideBar = _resolveComponent("SideBar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SideBar),
    _hoisted_1
  ], 64))
}